<template>
  <div class="gallery local_images_gallery">
    <appImageEditorGallery :items="items" :hideDelete="false" />
  </div>
</template>
<script>
import { mapState, mapActions } from "pinia";

import ImageEditorGallery from "../imageEditorGalleries/ImageEditorGallery";
import { useImageEditorStore } from "@/stores/modules/imageEditor";

export default {
  components: {
    appImageEditorGallery: ImageEditorGallery
  },
  computed: {
    ...mapState(useImageEditorStore, { items: "getImageGalleryItems" })
  }
};
</script>
